export const STRIPE_PORTAL_URL = {
  sandbox: 'https://billing.stripe.com/p/login/test_8x23cv2k94nvbzf1Eb6EU00',
  production: 'https://billing.stripe.com/p/login/fZudR90j709wgv9flM4c800',
};
